import { Component, ReactNode } from 'react'
import { DisabledTooltip } from './DisabledTooltip'

interface DisabledFeatureProps {
  children: React.ReactNode
  enabled: boolean
  reason: string
  action?: string
  tooltipId?: string
}

// Error Boundary für Tooltip-Komponente
class TooltipErrorBoundary extends Component<{ children: ReactNode }, { hasError: boolean }> {
  constructor(props: { children: ReactNode }) {
    super(props)
    this.state = { hasError: false }
  }

  static getDerivedStateFromError() {
    return { hasError: true }
  }

  render() {
    if (this.state.hasError) {
      return <span className="text-red-500 text-xs ml-1">!</span>
    }
    return this.props.children
  }
}

export function DisabledFeature({ children, enabled, reason, action, tooltipId }: DisabledFeatureProps) {
  return (
    <TooltipErrorBoundary>
      <div className="flex items-center gap-1">
        <div
          className={!enabled ? 'opacity-50 cursor-not-allowed' : ''}
          aria-disabled={!enabled}
          aria-describedby={!enabled && tooltipId ? tooltipId : undefined}
        >
          {children}
        </div>
        {!enabled && (
          <DisabledTooltip 
            reason={reason} 
            action={action}
            id={tooltipId}
          />
        )}
      </div>
    </TooltipErrorBoundary>
  )
}
